module.exports = __webpack_public_path__ + "57e40ce1.svg";